module.exports = __webpack_public_path__ + "static/media/ic-star-filled.c224a947.svg";